(function () {
  var SEL = '.product__media-item .product-media-container.media-type-image';
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var current = null;
  var hinted = false;

  function box(el) { return el.getBoundingClientRect(); }

  function setOrigin(el, x, y) {
    var r = box(el);
    var px = Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100));
    var py = Math.min(100, Math.max(0, ((y - r.top) / r.height) * 100));
    el.style.setProperty('--cw-zx', px.toFixed(1) + '%');
    el.style.setProperty('--cw-zy', py.toFixed(1) + '%');
  }

  function zoomIn(el, x, y) {
    if (current && current !== el) zoomOut();
    current = el;
    setOrigin(el, x, y);
    el.classList.add('cw-zoomed');
    hideHints();
  }

  function zoomOut() {
    if (!current) return;
    current.classList.remove('cw-zoomed');
    current.style.removeProperty('--cw-zx');
    current.style.removeProperty('--cw-zy');
    current = null;
  }

  function hideHints() {
    document.querySelectorAll('.cw-zoom-hint').forEach(function (h) { h.classList.add('is-gone'); });
    hinted = true;
  }

  function addHints() {
    if (canHover || hinted) return;
    document.querySelectorAll(SEL).forEach(function (c) {
      if (c.querySelector('.cw-zoom-hint')) return;
      var h = document.createElement('span');
      h.className = 'cw-zoom-hint';
      h.textContent = 'Double-tap to zoom';
      c.appendChild(h);
    });
  }

  /* ---------- Desktop: hover ---------- */
  if (canHover) {
    document.addEventListener('mousemove', function (e) {
      var el = e.target.closest && e.target.closest(SEL);
      if (!el) { zoomOut(); return; }
      if (current !== el) zoomIn(el, e.clientX, e.clientY);
      else setOrigin(el, e.clientX, e.clientY);
    }, { passive: true });
    document.addEventListener('mouseleave', zoomOut);
    window.addEventListener('blur', zoomOut);
  }

  /* ---------- Phone: double-tap to zoom, drag to look around while zoomed ----------
     A "press and hold" gesture was tried first, but the picture now fills almost
     the whole screen, so nearly every scroll attempt starts by touching it -- if
     the finger paused for a moment before moving (very common), the hold fired
     and swallowed the scroll. Double-tap can never be confused with a scroll
     drag, so it doesn't have that problem. */
  var TAP_MAX_MS = 250;
  var TAP_MAX_MOVE = 12;
  var DOUBLE_TAP_MS = 350;
  var DOUBLE_TAP_DIST = 40;

  var touchStartX = 0, touchStartY = 0, touchStartT = 0, touchTarget = null;
  var lastTapT = 0, lastTapX = 0, lastTapY = 0, lastTapEl = null;
  var panTarget = null;
  var swallowUntil = 0;

  document.addEventListener('click', function (e) {
    if (Date.now() < swallowUntil) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  document.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) { touchTarget = null; panTarget = null; return; }
    var el = e.target.closest && e.target.closest(SEL);
    touchTarget = el || null;
    if (!el) return;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchStartT = Date.now();
    panTarget = current === el ? el : null;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (panTarget && e.touches.length === 1) {
      e.preventDefault();
      var t = e.touches[0];
      setOrigin(panTarget, t.clientX, t.clientY);
    }
  }, { passive: false });

  function endTouch(e) {
    var el = touchTarget;
    touchTarget = null;
    panTarget = null;
    if (!el) return;
    var t = e.changedTouches && e.changedTouches[0];
    if (!t) return;

    var dt = Date.now() - touchStartT;
    var dx = Math.abs(t.clientX - touchStartX);
    var dy = Math.abs(t.clientY - touchStartY);
    if (dt >= TAP_MAX_MS || dx >= TAP_MAX_MOVE || dy >= TAP_MAX_MOVE) return;

    var now = Date.now();
    var isDouble = lastTapEl === el && (now - lastTapT) < DOUBLE_TAP_MS &&
      Math.abs(t.clientX - lastTapX) < DOUBLE_TAP_DIST && Math.abs(t.clientY - lastTapY) < DOUBLE_TAP_DIST;

    if (isDouble) {
      e.preventDefault();
      if (current === el) zoomOut(); else zoomIn(el, t.clientX, t.clientY);
      swallowUntil = Date.now() + 400;
      lastTapT = 0; lastTapEl = null;
    } else if (current === el) {
      /* A single tap while already zoomed in backs out, rather than opening
         the picture viewer underneath. */
      zoomOut();
      swallowUntil = Date.now() + 400;
      lastTapT = 0; lastTapEl = null;
    } else {
      lastTapT = now; lastTapX = t.clientX; lastTapY = t.clientY; lastTapEl = el;
    }
  }

  document.addEventListener('touchend', endTouch, { passive: false });
  document.addEventListener('touchcancel', function () { touchTarget = null; panTarget = null; }, { passive: true });

  document.addEventListener('contextmenu', function (e) {
    if (e.target.closest && e.target.closest(SEL) && !canHover) e.preventDefault();
  });

  addHints();
  document.addEventListener('shopify:section:load', addHints);
  window.addEventListener('load', addHints);
})();
